import { render, staticRenderFns } from "./FCBot.vue?vue&type=template&id=1dd6c01b&scoped=true&"
import script from "./FCBot.vue?vue&type=script&lang=js&"
export * from "./FCBot.vue?vue&type=script&lang=js&"
import style0 from "./FCBot.vue?vue&type=style&index=0&id=1dd6c01b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd6c01b",
  null
  
)

export default component.exports